import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-389d4456"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setupHead flex-ter" }
const _hoisted_2 = ["onClick"]

import { ref } from 'vue'
import { isD2C } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['tabs', 'activeTab'],
  emits: ['update:activeTab', 'tabClick'],
  setup(__props, { emit: emits }) {

const props = __props


const tabClick = (tab: string) => {
  console.log(tab)
  // emits('update:activeTab', name)
  emits('tabClick', tab)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (i) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: i.label
      }, [
        (!i.hidden)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({
          headItem: true,
          activeTab: i.name === __props.activeTab,
          'flex-cen-ter': true,
          'cursor-pt': true,
        }),
              onClick: ($event: any) => (tabClick(i))
            }, _toDisplayString(i.label), 11, _hoisted_2))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})